import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { func, string, arrayOf, number } from 'prop-types';
import Radium from 'radium';
import Badge from '@material-ui/core/Badge';

import { actionCreators as notificationActions, notificationPropTypes } from 'redux/notificationHandlers';
import { accountPropTypes } from 'redux/accountHandlers';
import { appConfig } from 'config/customization';
import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';
import { ROUTES } from 'constants/routes';
import { BILL, FORM_RESPONSE, CLAIM, PROCEDURE } from 'constants/userForms';

import NotificationList from './components/NotificationList';
import styles from './styles.module.scss';

class TopBarDropDown extends Component {
  state = { imgIcon: this.props.icon, showNotificationsDropDown: false };

  componentWillMount() {
    document.addEventListener('click', this.handleShouldCloseDropdown);
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.currentAccount && this.props.currentAccount !== nextProps.currentAccount)
      this.setState({ showNotificationsDropDown: false });
  };

  onClickNotification = id => {
    const clickedNotif = this.props.rows.find(elem => elem.id === id);
    switch (clickedNotif.notification_type) {
      case BILL:
        this.props.redirectTo(ROUTES.BILLS);
        break;
      case FORM_RESPONSE:
        if (appConfig.procedures.useProcedureList && clickedNotif.form_type === PROCEDURE)
          return this.props.redirectTo(ROUTES.PROCEDURES);
        if (appConfig.claims.useClaimList && clickedNotif.form_type === CLAIM)
          return this.props.redirectTo(ROUTES.CLAIMS);
        break;
      default:
    }
    return null;
  };

  onMouseEnter = () => this.setState({ imgIcon: this.props.hoverIcon });

  onMouseLeave = () => this.setState({ imgIcon: this.props.icon });

  onClick = event => {
    event.stopPropagation();
    this.setState(
      { showNotificationsDropDown: !this.state.showNotificationsDropDown },
      () =>
        (!this.state.showNotificationsDropDown &&
          this.props.setNotificationsSeen() &&
          document.removeEventListener('click', this.handleShouldCloseDropdown)) ||
        (this.state.showNotificationsDropDown &&
          document.addEventListener('click', this.handleShouldCloseDropdown))
    );
  };

  setContainerElem = topBarDropdown => (this.topBarDropdown = topBarDropdown);

  handleShouldCloseDropdown = event => {
    if (!this.state.showNotificationsDropDown) return;
    if (this.topBarDropdown && !this.topBarDropdown.contains(event.target)) {
      this.setState(
        {
          showNotificationsDropDown: false
        },
        () =>
          this.props.setNotificationsSeen() &&
          document.removeEventListener('click', this.handleShouldCloseDropdown)
      );
    }
  };

  render() {
    const { notificationAmount } = this.props;
    return (
      <div className={styles.container}>
        <UTTouchableWithoutFeedback
          onClick={this.onClick}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          containerSetter={this.setContainerElem}
        >
          <Badge
            badgeContent={notificationAmount}
            classes={{ badge: notificationAmount ? styles.badge : styles.hiddenBadge }}
          >
            <img className={styles.button} src={this.state.imgIcon} alt="Notifications" />
          </Badge>
          {this.state.showNotificationsDropDown ? (
            <NotificationList rows={this.props.rows} onClickNotification={this.onClickNotification} />
          ) : (
            <div className={styles.containerHidden} />
          )}
        </UTTouchableWithoutFeedback>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setNotificationsSeen: () => dispatch(notificationActions.setNotificationsSeen()),
  redirectTo: route => dispatch(push(route))
});

const mapStateToProps = store => ({
  rows: store.notification.notificationList,
  currentAccount: store.account.currentAccount
});

TopBarDropDown.propTypes = {
  rows: arrayOf(notificationPropTypes).isRequired,
  icon: string.isRequired,
  hoverIcon: string.isRequired,
  notificationAmount: number.isRequired,
  setNotificationsSeen: func,
  redirectTo: func,
  currentAccount: accountPropTypes
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(TopBarDropDown), 8);
